export const GSTR2_REPORT_REQUEST = 'GSTR2_REPORT_REQUEST';
export const GSTR2_REPORT_SUCCESS = 'GSTR2_REPORT_SUCCESS';
export const GSTR2_REPORT_FAILURE = 'GSTR2_REPORT_FAILURE';